import React, { useState } from "react"


import { Stack } from "@mui/material"
import { errorJsonHasErrors } from "./Input_Fns"
import { set } from "lodash"
import { InputSelectN } from "./Select"
import { useEffect } from "react"


export const InputAccountsTypesNames = ({
    avail, inputForm, onChange,
    accountsDisabled = () => { return false },
    typesDisabled = () => { return false },
    MenuProps,
    width = 320,
    onError,
    both_allowed = false,
    max = 0,
    doValidation,
}) => {
    const [form, setForm] = useState({ names: inputForm.AccountNames, types: inputForm.AccountTypes })
    const [errors, setErrors] = useState({})

    const onChange_any = (n, v) => {
        console.log(form);
        let nf = {
            ...form,
            [n]: v,
        };
        console.log(nf);
        setForm(nf)
        onChange(nf.names, nf.types);
        return nf
    };

    const onChange_t = (e) => {
        console.log(e.target.name);
        console.log(e.target.value);
        let nf = onChange_any(e.target.name, e.target.value);
        validation(nf)
    };

    const validation = (f) => {
        let ne = structuredClone(errors)

        let errNames = ""
        let errTypes = ""
        console.log(f)
        let ignoreAccounts = accountsDisabled()
        let ignoreTypes = typesDisabled()


        if ((!ignoreAccounts && f.names.length === 0) &&
            (!ignoreTypes && f.types.length === 0)) {
            errNames = "Please enter a name or type"
            errTypes = errNames
        } else {
            if ((!both_allowed) && (f.names.length > 0 && f.types.length > 0)) {
                errNames = "Please enter only a name or a type"
                errTypes = errNames
            } else {
                if ((max !== 0) && (f.names.length + f.types.length) > max) {
                    errNames = "Please enter only " + max + " names " + (both_allowed ? "and" : "or") + " types"
                    errTypes = errNames
                }
            }
        }


        ne = set(ne, "names", errNames)
        ne = set(ne, "types", errTypes)
        console.log("onBlur acc Names/Types")
        console.log(errNames)
        setErrors(ne)
        if (onError !== null) {
            onError(errorJsonHasErrors(ne) ? "Errors" : "")
        }

    }

    useEffect(() => {
        validation(form)

    }, [doValidation])


    return (

        <Stack sx={{ m: 4 }} spacing={2} >

            <InputSelectN
                label="Accounts"
                name="names"
                value={form.names}
                onChange={onChange_t}
                minWidth={width}
                maxWidth={width}
                errors={errors}
                avail={avail.AccountNames}
                MenuProps={MenuProps}
                disabled={accountsDisabled()}

            />
            <InputSelectN
                label="Account Types"
                name="types"
                value={form.types}
                onChange={onChange_t}
                minWidth={width}
                maxWidth={width}
                errors={errors}
                avail={avail.AccountTypes}
                MenuProps={MenuProps}
                disabled={typesDisabled()}
            />
        </Stack >
    )
}
